import api from "../helpers/util";

export const fetchOrigins = async () => {
  try {
    const response = await api.get("/origins");
    console.log("origins", response?.data?.result);
    return response?.data?.result ?? "No origins found.";
  } catch (error) {
    throw new Error("Error fetching origins:", error);
  }
};

export const createorUpdateOrigin = async (originData, originId) => {
  try {
    if (originId) {
      const response = await api.put(`/origins/updateOrigin`, originData, {
        // headers: { "Content-Type": "multipart/form-data" },
      });
      //const data = await response.json();
      return response.data.result;
    } else {
      const response = await api.post("/origins/createOrigin", originData, {
        // headers: { "Content-Type": "multipart/form-data" },
      });
      console.log("data api", response);
      // const data = await response.json();
      // console.log("data api", data);
      return response.data.result;
    }
  } catch (error) {
    console.log("error api", error);
    throw new Error("Error updating origin:", error);
  }
};

// Fetch all contacts for an origin
export const fetchOriginContacts = async (originId) => {
  try {
    const response = await api.get(`/origins/${originId}/contacts`);
    return response?.data?.result ?? [];
  } catch (error) {
    throw new Error("Error fetching origin contacts:", error);
  }
};

// Bulk-replace all contacts for an origin
export const updateOriginContacts = async (originId, contacts) => {
  try {
    const response = await api.put(`/origins/${originId}/contacts`, {
      contacts,
    });
    return response.data.result;
  } catch (error) {
    console.log("error api", error);
    throw new Error("Error updating origin contacts:", error);
  }
};

export const deleteOrigin = async (originId) => {
  try {
    const response = await api.delete("/origins/" + originId);

    //const data = await response.json();
    console.log("origin", response);
    return response;
  } catch (error) {
    console.log("api err", error);
    throw error;
  }
};